// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import bgImage from 'assets/images/background.png';
import cardActions from 'actions/card';
import { HeaderContainer, HeaderContent } from 'components/shared/PageHeader/PageHeader';
import giftActions from 'actions/gift';
import Card from './Card';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'assets/css/shared.css';
import './styles.css';

const settings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
  arrows: true,
  prevArrow: <Arrow direction="prev" style onClick />,
  nextArrow: <Arrow direction="next" style onClick />,
};

type ArrowProps = {
  style: string,
  direction: string,
  onClick: Function,
};

function Arrow(props: ArrowProps) {
  const { style, onClick, direction } = props;
  return (
    <span
      className={`icon-arrow-button slick-arrow slick-${direction}`}
      style={style}
      onClick={onClick}
      aria-hidden="true"
    />
  );
}

const filterOptions = [
  {
    id: 1,
    value: 'all',
    text: 'All Goalcards',
    class: 'orange',
    icon: 'all',
  },
  {
    id: 2,
    value: 'birthday',
    text: 'Birthday',
    class: 'ligthblue',
    icon: 'birthday',
  },
  {
    id: 3,
    value: 'holiday',
    text: 'Holiday',
    class: 'blue',
    icon: 'holiday',
  },
  {
    id: 4,
    value: 'milestone_moments',
    text: 'Milestone',
    class: 'purple',
    icon: 'milestone',
  },
  {
    id: 5,
    value: 'just_because',
    text: 'Just Because',
    class: 'scarlet',
    icon: 'justbecause',
  },
];

type SelectCardProps = {
  cards: Array<any>,
  getCards: Function,
  setCard: Function
};

const SelectCard = (props: SelectCardProps) => {
  const history = useHistory();

  const location = useLocation();

  const { getCards, setCard } = props;
  const { t } = useTranslation();

  const onSelect = (selectedCard) => {
    setCard(selectedCard);

    history.push('/customize');
  };

  const [filteredCards, setfilteredCards]: [any,
    (((any) => any) | any) => void
  ] = useState({ cards: [], title: '' });

  useEffect(() => {
    if (location.state && location.state.receiverUser) {
      const { setGoalcardReceiver } = props;

      setGoalcardReceiver(location.state.receiverUser);
    }

    if (location.state && location.state.receiverGoal) {
      const { setGoalcardDestinationGoal } = props;

      setGoalcardDestinationGoal(location.state.receiverGoal);
    }
  }, [location]);

  const LoadCards = () => {
    useEffect(() => {
      window.scrollTo(0, 0);

      const { cards } = props;

      if (cards) {
        setfilteredCards({ cards });
      }

      getCards().then((result) => {
        setfilteredCards({ cards: result, title: 'All GoalCards' });
      });
    }, []);

    return (
      <>
        <section className="goalcards-items-section">
          <div className="container">
            <h2 className="section-title">{filteredCards.title}</h2>
            <div className="goalcards-items">
              {filteredCards.cards
                && filteredCards.cards.map((card) => (
                  <Card
                    cardId={card.rid}
                    imageSrc={card.imageURL}
                    key={card.rid}
                    onSelect={onSelect}
                  />
                ))}
            </div>
          </div>
        </section>
      </>
    );
  };

  const FilterCards = (e, data, title) => {
    e.preventDefault();

    if (data === 'all') {
      setfilteredCards({ cards: props.cards, title });
    } else {
      setfilteredCards({
        cards: props.cards.filter((x) => x.cardType === data),
        title,
      });
    }
  };

  const LoadFilters = (options) => options.map((option) => (
    <div
      key={option.id}
      className={`goalcards-category ${option.class}`}
      onClick={(e) => FilterCards(e, option.value, option.text)}
      aria-hidden="true"
    >
      <div className="card-link">
        <span className={`goalcards-category-icon ${option.icon}`} />
        <div className="goalcards-category-label">{option.text}</div>
      </div>
    </div>
  ));

  return (
    <>
      <HeaderContainer backgroundImage={bgImage}>
        <HeaderContent>
          {t('goalsetter_sendgoalcard')}
        </HeaderContent>
      </HeaderContainer>
      <div className="main-content goalcards-content">
        <div className="goalcards-categories-section">
          <div className="container">
            <Slider className="goalcards-categories" {...settings}>
              {LoadFilters(filterOptions)}
            </Slider>
          </div>
        </div>
        {LoadCards()}
      </div>
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.selectCard.isProcessing,
  cards: state.selectCard.cards,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getCards: () => dispatch(cardActions.getCards()),
  setCard: (card) => dispatch(cardActions.setCard(card)),
  setGoalcardReceiver: (receiver: Any) => dispatch(
    giftActions.setGoalcardReceiver(receiver),
  ),
  setGoalcardDestinationGoal: (goal: Any) => dispatch(
    giftActions.setGoalcardDestinationGoal(goal),
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectCard);
